import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { HvlFormConstants } from '@hvlng/framework-core/form';
import '../../../../common/extension/form-group-extension';
import { HvlConfigurationService } from '@hvlng/framework-bff/core';
import { HrBaseMultiLangFormPageNew } from '../../../../common/base-form/hr-base-multi-lang-form-page-new';
import { CodeTextDiscriminatorDetailModel } from '../../model/code-text-discriminator-detail-model';
import { CodeTextDiscriminatorModel } from '../../model/code-text-discriminator-model';
import { CodeTextService } from '../../service/code-text-service';
import { HrHvlFormGroup } from '../../../../common/model/hr-hvlng-form-group';
import { ActivatedRoute } from '@angular/router';
import { HrModuleType } from '../../../../common/model/hr-module-type';
import { PayrollCodeTextModel } from '../../model/payroll-code-text-model';
import { DropdownOption, uiClientSideValidator } from 'ui-shared';

@Component({
    selector: 'code-text-form',
    templateUrl: './code-text-form.component.html',
})
export class CodeTextFormComponent
    extends HrBaseMultiLangFormPageNew<CodeTextDiscriminatorDetailModel>
    implements OnInit {
    @Input() selectedDiscriminator: DropdownOption = null;
    @Input() selectedItem: any;
    @Output() setAllButtonDisabledEvent = new EventEmitter<boolean>();
    routeName: HrModuleType;

    codeTextForm = new HrHvlFormGroup<CodeTextDiscriminatorModel>(new CodeTextDiscriminatorModel());
    codeTextValueForm = new HrHvlFormGroup<CodeTextDiscriminatorDetailModel>(new CodeTextDiscriminatorDetailModel());
    codeTextModel;

    constructor(
        private codeTextService: CodeTextService,
        public configurationService: HvlConfigurationService,
        private injector: Injector,
        private activatedRoute: ActivatedRoute,
    ) {
        super(configurationService, CodeTextDiscriminatorDetailModel, injector);

        this.activatedRoute.data.subscribe((params) => {
            this.routeName = params.module;
            if (params.module == HrModuleType.PAYROLL) {
                this.codeTextForm = new HrHvlFormGroup<PayrollCodeTextModel>(new PayrollCodeTextModel());
            }
        });
    }
    ngOnInit(): void {
        this.codeTextForm.addControl('detailMap', this.mlForm); /* Added for Definition Map */
        super.setDefaultDetailMap(); /* Added for Definition Map */
    }
    getData() {
        this.serviceCall.callFormService(
            this,
            this.codeTextService.getById(this.selectedDiscriminator?.value, this.selectedItem.id, this.routeName),
            (response) => {
                this.selectedItem.detailMap = response.detailMap;
                if (this.formMode === HvlFormConstants.COPY) {
                    if (this.routeName == HrModuleType.PAYROLL) {
                        this.codeTextForm.get('beginDate').setValue(response.beginDate);
                        this.codeTextForm.get('endDate').setValue(response.endDate);
                    }
                    this.codeTextForm.get('code').setValue(response.code);

                    super.setMlFormWhenEditCopy(this.selectedItem);
                } else if (this.formMode === HvlFormConstants.EDIT) {
                    super.setMlFormWhenEditCopy(this.selectedItem);
                    this.codeTextForm.patchValueByFormMode(response, this.formMode);
                } else if (this.formMode === HvlFormConstants.REMOVE) {
                    super.setMlFormWhenEditCopy(this.selectedItem);
                    this.codeTextForm.patchValueByFormMode(response, this.formMode);
                } else {
                    this.codeTextForm.patchValueByFormMode(response, this.formMode);
                }
            },
        );
    }

    openAddForm() {
        this.setAllButtonDisabledEvent.emit(true);
        this.openPageForm(HvlFormConstants.ADD);
    }

    openRemoveForm() {
        this.setAllButtonDisabledEvent.emit(true);
        this.openPageForm(HvlFormConstants.REMOVE);
        this.codeTextForm.disable();
    }

    openEditForm() {
        this.setAllButtonDisabledEvent.emit(true);
        this.openPageForm(HvlFormConstants.EDIT);
    }

    openViewForm() {
    }

    openCopyForm() {
        this.setAllButtonDisabledEvent.emit(true);
        this.openPageForm(HvlFormConstants.COPY);
    }

    initializeData() {
        this.codeTextForm.reset();
        this.codeTextValueForm.reset();
        if (this.formMode === HvlFormConstants.ADD) {
            super.setDefaultDetailMap();
            return;
        }
        if (
            this.formMode === HvlFormConstants.EDIT ||
            this.formMode === HvlFormConstants.REMOVE ||
            this.formMode === HvlFormConstants.COPY
        ) {
            this.getData();
            // this.codeTextValueForm.patchValue(this.selectedItem.detailMap.get(this.selectedLanguage));
            super.setMlFormWhenEditCopy(this.selectedItem);
        } else {
            this.onFindNextOrderLevel();
        }
    }

    onSave() {
        super.setDetailMapToForm(this.codeTextForm); /* Added for Definition Map */
        uiClientSideValidator(this.codeTextForm);
        if (this.codeTextForm.invalid)
            return;

        let orderLevel = this.codeTextForm.value.orderLevel;
        if (orderLevel && orderLevel > 0) {
            this.codeTextService
                .existsByDiscriminatorAndOrderLevelAndIsNotId(orderLevel, this.selectedDiscriminator?.value, this.selectedItem?.id ?? '', this.routeName)
                .subscribe((isExist) => {
                    if (isExist) {
                        this.confirmationDialogService.showBasicConfirmDialog(
                            this.translateSync(this.hrKey.hrCommonCodeText.orderLevelConflictHeader),
                            this.translateSync(this.hrKey.hrCommonCodeText.orderLevelConflictMessage),
                            () => {
                                this.processSave();
                            },
                        );
                    } else {
                        this.processSave();
                    }
                });
        } else {
            this.processSave();
        }
    }

    private processSave() {
        if (this.formMode === HvlFormConstants.EDIT) {
            if (this.routeName == HrModuleType.PAYROLL) {
                this.selectedItem.beginDate = this.codeTextForm.get('beginDate').value;
                this.selectedItem.endDate = this.codeTextForm.get('endDate').value;
            }

            this.selectedItem.discriminator = this.selectedDiscriminator?.value;
            this.serviceCall.callFormService(
                this,
                this.codeTextService.update(this.codeTextForm.value, this.routeName),
                this.onServiceCompleted,
                {
                    editMessage: this.getCodeTextTitle(),
                },
            );
        } else {
            this.codeTextModel = this.codeTextForm.value;
            this.codeTextModel.shortText = this.codeTextValueForm.get('shortText').value;
            this.codeTextModel.longText = this.codeTextValueForm.get('longText').value;
            this.codeTextModel.discriminator = this.selectedDiscriminator?.value;

            this.serviceCall.callFormService(
                this,
                this.codeTextService.save(this.codeTextModel, this.routeName),
                this.onServiceCompleted,
                {
                    saveMessage: this.getCodeTextTitle(),
                },
            );
        }
    }

    onServiceCompleted = (_: any) => {
        this.resetAndCloseForm(true);
    };

    onCancel() {
        this.resetAndCloseForm(false);
    }

    onRemove() {
        this.confirmationDialogService.showDeleteConfirmDialog(() => {
            this.serviceCall.callFormService(
                this,
                this.codeTextService.deleteById(this.selectedDiscriminator?.value, this.selectedItem.id, this.routeName),
                this.onServiceCompleted,
                {
                    deleteMessage: this.getCodeTextTitle(),
                },
            );
        });
    }

    onFindNextOrderLevel() {
        this.codeTextService.findMaxOrderLevelByDiscriminator(this.selectedDiscriminator?.value, this.routeName).subscribe((lastVal) => {
            let nextVal = lastVal ? lastVal + 1 : 1;
            this.codeTextForm.patchValue({
                orderLevel: nextVal,
            });
        });
    }

    private openPageForm(formMode: HvlFormConstants): void {
        let formTitle = this.getFormTitleSync(this.getCodeTextTitle(), formMode);
        this.openForm(formMode, formTitle);
        this.initializeData();
    }

    private getCodeTextTitle() {
        return this.selectedDiscriminator?.label;
    }

    private resetAndCloseForm(refreshTable: boolean) {
        this.codeTextForm.markAllAsUntouched();
        this.codeTextValueForm.markAllAsUntouched();
        this.codeTextForm.reset();
        this.codeTextValueForm.reset();
        this.codeTextForm.enable();
        this.codeTextValueForm.enable();
        this.onCloseEvent.emit(refreshTable);
    }
}
